import { Toggle } from "@mm/metx-design-system";
import type React from "react";

export type ToggleSwitchProps = {
  id?: string;
  name?: string;
  checked?: boolean; // controlled
  defaultChecked?: boolean; // uncontrolled
  onChange?: (checked: boolean, ev: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  name,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  className,
}) => {
  return (
    <Toggle
      id={id}
      name={name}
      disabled={disabled}
      checked={checked}
      defaultChecked={defaultChecked}
      className={className}
      onChange={(e) => onChange?.(e.target.checked, e)}
    />
  );
};

export default ToggleSwitch;
